import styled from 'styled-components';
import { COLORS } from 'styles/variables';

export const UpperNoteWrapper = styled.div`
  position: relative;

  span.special-text {
    color: ${COLORS.BLUE_1};

    &.bold {
      font-weight: bold;
    }
  }

  .decoration-image {
    position: absolute;
    width: 50rem;
    top: -9rem;
    right: 32rem;
  }
`;
